import React from "react";
export default function ProductRackCell(props) {
  return (
    <>
      {props.rack && (
        <span className="mx-1" title="Полка">
          <i className="fa flaticon2-menu-3 mr-2"></i>
          {props.rack}
        </span>
      )}
      {props.cell && (
        <span className="mx-1" title="Ячейка">
          <i className="fa flaticon2-setup mr-2"></i>
          {props.cell}
        </span>
      )}
    </>
  );
}
